const { DefaultEventTypes } = require('./default');

const PROGRAMS_TAG = 'programs';

const ProgramEvents = {
  SUCCESS: `${PROGRAMS_TAG}.${DefaultEventTypes.SUCCESS}`,
  FAILED: `${PROGRAMS_TAG}.${DefaultEventTypes.FAILED}`,
};

module.exports = { ProgramEvents, PROGRAMS_TAG };
